/**
 * Format khoảng ngân sách người dùng (min–max) thành chuỗi hiển thị.
 *
 * Hỗ trợ các trường hợp: chỉ min, chỉ max, cả hai, hoặc chưa cung cấp.
 */
import { formatText } from '../languages';
import { formatCurrency } from './formatCurrency';

/**
 * Tạo chuỗi mô tả khoảng ngân sách.
 * @param {number|null} min - Ngân sách tối thiểu
 * @param {number|null} max - Ngân sách tối đa
 * @param {Object} labels - Nhãn i18n: notProvided, budgetFrom, budgetUpTo
 * @returns {string|null}
 */
export const formatBudgetRange = (min, max, labels) => {
  const { notProvided, budgetFrom, budgetUpTo } = labels;

  if (!min && !max) {
    return notProvided;
  }

  if (min && max) {
    return `${formatCurrency(min)} – ${formatCurrency(max)}`;
  }

  if (min) {
    return formatText(budgetFrom, { amount: formatCurrency(min) });
  }

  return formatText(budgetUpTo, { amount: formatCurrency(max) });
};
